import * as React from "react";

interface Props {
  width: number
  height: number
}

const DocumentImageIcon = ({ width = 800, height = 800, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1024 1024"
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M853.333333 874.666667H170.666667c-46.933333 0-85.333333-38.4-85.333334-85.333334V234.666667c0-46.933333 38.4-85.333333 85.333334-85.333334h682.666666c46.933333 0 85.333333 38.4 85.333334 85.333334v554.666666c0 46.933333-38.4 85.333333-85.333334 85.333334z"
      fill="#F57C00"
    />
    <path
      d="M746.666667 341.333333m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
      fill="#FFF9C4"
    />
    <path
      d="M426.666667 341.333333L192 682.666667h469.333333z"
      fill="#942A09"
    />
    <path
      d="M661.333333 469.333333l-170.666666 213.333334h341.333333z"
      fill="#BF360C"
    />
  </svg>
);
export default DocumentImageIcon;
